'use client';

import React from 'react';

const footerLinks = [
  {
    heading: 'Services',
    links: [
      { label: 'Business Consulting', href: '#services' },
      { label: 'Technology Consulting', href: '#services' },
      { label: 'Management Services', href: '#services' },
      { label: 'Research & Analysis', href: '#services' },
      { label: 'Engineering Services', href: '#services' },
      { label: 'Financial Advisory', href: '#services' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us', href: '#about' },
      { label: 'Why Choose Us', href: '#why-us' },
      { label: 'Our Process', href: '#why-us' },
      { label: 'Contact Us', href: '#contact' },
    ],
  },
  {
    heading: 'Industries',
    links: [
      { label: 'Technology', href: '#services' },
      { label: 'Manufacturing', href: '#services' },
      { label: 'Healthcare', href: '#services' },
      { label: 'Financial Services', href: '#services' },
      { label: 'Retail & CPG', href: '#services' },
      { label: 'Energy & Utilities', href: '#services' },
    ],
  },
  {
    heading: 'Contact',
    links: [
      { label: '174 Hobbs Court', href: '#contact' },
      { label: 'Milpitas, CA 95035', href: '#contact' },
      { label: '(203) 627-7377', href: 'tel:2036277377' },
      { label: 'support@plyto7.com', href: 'mailto:support@plyto7.com' },
    ],
  },
];

export default function Footer() {
  const scrollToSection = (href: string) => {
    if (href.startsWith('#')) {
      const id = href.replace('#', '');
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = 2025;

  return (
    <footer
      style={{
        background: 'linear-gradient(180deg, #0A0A0A 0%, #0A1526 100%)',
        borderTop: '1px solid rgba(255, 255, 255, 0.06)',
      }}
    >
      {/* Top CTA bar */}
      <div
        className="py-12 px-6"
        style={{
          background: 'linear-gradient(135deg, rgba(66, 132, 245, 0.15) 0%, rgba(33, 66, 123, 0.15) 100%)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        }}
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-2xl mb-2">
              Ready to Get Started?
            </h3>
            <p className="text-gray-400">
              Schedule a free consultation with our expert team today.
            </p>
          </div>
          <div className="flex gap-4">
            <button
              onClick={() => scrollToSection('#contact')}
              className="px-7 py-3 text-white font-semibold rounded-btn transition-all duration-200 hover:opacity-90"
              style={{ background: 'linear-gradient(291deg, #4284F5 0%, #21427B 100%)' }}
            >
              Request a Consultation
            </button>
            <button
              onClick={() => scrollToSection('#services')}
              className="px-7 py-3 font-semibold rounded-btn transition-all duration-200 hover:bg-white/10"
              style={{
                border: '2px solid rgba(66, 132, 245, 0.5)',
                color: '#60A5FA',
                background: 'transparent',
              }}
            >
              Explore Services
            </button>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-5 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center"
                style={{ background: 'linear-gradient(135deg, #4284F5, #21427B)' }}
              >
                <span className="text-white font-black text-sm">P7</span>
              </div>
              <div>
                <div className="text-white font-bold text-lg leading-tight">Pluto7</div>
                <div className="text-gray-400 text-xs">Consulting Inc.</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Professional business consulting and management services for organizations seeking
              sustainable growth and operational excellence.
            </p>
            <div
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-xs"
              style={{
                background: 'rgba(66, 132, 245, 0.1)',
                border: '1px solid rgba(66, 132, 245, 0.2)',
                color: '#60A5FA',
              }}
            >
              <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
              Business Consulting, NEC
            </div>
          </div>

          {/* Links columns */}
          {footerLinks.map((col, i) => (
            <div key={i}>
              <h4
                className="text-white font-bold text-sm mb-5 uppercase tracking-wider"
                style={{ letterSpacing: '0.08em' }}
              >
                {col.heading}
              </h4>
              <div
                className="w-8 h-0.5 mb-5"
                style={{ background: 'linear-gradient(90deg, #4284F5, transparent)' }}
              />
              <ul className="flex flex-col gap-3">
                {col.links.map((link, j) => (
                  <li key={j}>
                    {link.href.startsWith('#') ? (
                      <button
                        onClick={() => scrollToSection(link.href)}
                        className="text-gray-400 text-sm hover:text-primary transition-colors duration-200 text-left"
                      >
                        {link.label}
                      </button>
                    ) : (
                      <a
                        href={link.href}
                        className="text-gray-400 text-sm hover:text-primary transition-colors duration-200 break-all"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="px-6 py-6"
        style={{ borderTop: '1px solid rgba(255, 255, 255, 0.06)' }}
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Pluto7 Consulting Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-gray-500 text-sm">Engineering &bull; Accounting &bull; Research &bull; Management</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
